import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Link } from 'react-scroll'
import { Menu, Badge } from 'antd'
import { loadUser } from '../../../utils/storage'
import { CharacterLevel, userType } from '../../../utils/constant'

import { styles } from './index.sass'
import './index.css'
import {
  ExcludeCharacters,
  PagePermissions
} from '../../../utils/authManagement'

const {
  PROGRAM,
  MESSAGING,
  NOTES,
  SUPPORT_TEAM,
  TRENDS,
  FILES,
  WEEKLY_INSIGHTS,
  HEALTH_COMPASS,
  NUTRITION_SIGNALS_REPORT,
  NUTRITION_SIGNALS_TRENDS,
  // VITALS,
  BODY_COMPOSITION,
  // BONE_DENSITY,
  MOVEMENT_QUALITY_BALANCE,
  MUSCLE_FITNESS,
  AEROBIC_FITNESS,
  COGNITIVE_HEALTH,
  BLOOD_PANEL,
  TIMELINE
} = PagePermissions

const { SubMenu, Item } = Menu
export const datasetTypes = [
  // {
  //   path: 'vitals',
  //   key: 'vitals',
  //   menuKey: 'vitals',
  //   originKey: 'body_comp',
  //   menuTitle: 'Vitals',
  //   // permission: ['Expert', 'User', 'InternalAdmin'],
  //   characters: ExcludeCharacters([CharacterLevel.service_provider]),
  //   perm: VITALS,
  //   hasSubMenu: true
  // },
  {
    path: 'body-comp',
    key: 'bodyCom',
    menuKey: 'body_comp',
    menuTitle: 'Body Composition',
    // permission: ['Expert', 'User', 'InternalAdmin'],
    characters: ExcludeCharacters([CharacterLevel.service_provider]),
    perm: BODY_COMPOSITION,
    hasSubMenu: true
  },
  // {
  //   path: 'bone-density',
  //   key: 'boneDensity',
  //   menuKey: 'bone_density',
  //   originKey: 'body_comp',
  //   menuTitle: 'Bone Density',
  //   // permission: ['Expert', 'User', 'InternalAdmin'],
  //   characters: ExcludeCharacters([CharacterLevel.service_provider]),
  //   perm: BONE_DENSITY,
  //   hasSubMenu: true
  // },
  {
    path: 'movement-quality',
    key: 'movementQuality',
    menuTitle: 'Movement Quality & Balance',
    menuKey: 'movement_quality',
    originKey: 'physical_assessment',
    // permission: ['Expert', 'User', 'InternalAdmin'],
    characters: ExcludeCharacters([CharacterLevel.service_provider]),
    perm: MOVEMENT_QUALITY_BALANCE,
    hasSubMenu: true
  },

  {
    path: 'muscle-fitness',
    key: 'muscleFitness',
    menuKey: 'muscle_fitness',
    originKey: 'physical_assessment',
    menuTitle: 'Muscle Fitness', //'Initial 360 Physical Evaluation',
    // permission: ['Expert', 'User', 'InternalAdmin'],
    characters: ExcludeCharacters([CharacterLevel.service_provider]),
    perm: MUSCLE_FITNESS,
    hasSubMenu: true
  },
  {
    path: 'aerobic-fitness',
    key: 'aerobicFitness',
    menuKey: 'aerobic_fitness',
    originKey: 'cardiorespiratory',
    menuTitle: 'Aerobic Fitness', //'Cardiovascular Fitness',
    // permission: ['Expert', 'User', 'InternalAdmin'],
    characters: ExcludeCharacters([CharacterLevel.service_provider]),
    perm: AEROBIC_FITNESS,
    hasSubMenu: true
  },
  {
    path: 'cognitive-health',
    key: 'cognitive_health',
    menuKey: 'cognitive_health',
    menuTitle: 'Cognitive Health',
    // permission: ['Expert', 'User', 'InternalAdmin'],
    characters: ExcludeCharacters([CharacterLevel.service_provider]),
    perm: COGNITIVE_HEALTH,
    hasSubMenu: true
  },
  {
    path: 'blood-test',
    key: 'blood_test',
    menuKey: 'bio_marker',
    menuTitle: 'Blood Panel',
    // permission: ['Expert', 'User', 'InternalAdmin'],
    characters: ExcludeCharacters([CharacterLevel.service_provider]),
    perm: BLOOD_PANEL,
    hasSubMenu: true
  }
]

class ClientSlideMenu extends Component {
  static propTypes = {
    location: PropTypes.object,
    loginRole: PropTypes.string,
    datasetCount: PropTypes.array
  }

  state = {
    isCollaps: false,
    menuList: []
  }

  handleClick = (menu) => {
    const {
      hrefs,
      history,
      loginRole,
      location: { pathname },
      slideMenu: { groups }
    } = this.props
    if (menu.keyPath) {
      this.setState({
        // isCollaps: !this.state.isCollaps,
        selectedKeys: menu.keyPath
      })
    }
    const href = hrefs[menu.key]
    if (href) {
      history && history.push(href)
    } else {
      const [page, category] = menu.key.split('+')
      const targetMenu = this.state.menuList.find((item) => item.path === page)
      const type = targetMenu.menuKey
      const target = groups[type].categories.find(
        ({ name }) => name.replace(/ /g, '_') === category
      )
      if (target) {
        if (loginRole === 'User') {
          history.push(`/app/dataset/${page}/${target.name}`)
        } else if (loginRole === 'Public') {
          const pathArr = pathname.split('/')
          pathArr.splice(2, 1, page)
          pathArr.splice(4, 1, target.name)
          history.push(pathArr.join('/'))
        } else {
          const path = pathname.split('/detail')[0]
          history.push(`${path}/detail/${page}/${target.name}`)
        }
      }
    }
  }

  subMenuClickHandle = (menu) => {
    if (this.state.isInitial) {
      this.setState({ isInitial: false })
    }
    const {
      hrefs,
      history,
      location: { pathname }
    } = this.props
    let isCollaps = this.state.isCollaps
    if (menu.keys) {
      let selectedKeys = menu.keys.concat(this.state.selectedKeys || [])
      if (_.includes(this.state.selectedKeys, menu.keys[0])) {
        if (this.state.selectedKeys.length > 2) {
          selectedKeys = this.state.selectedKeys.filter(
            (item) => item !== menu.keys[0]
          )
        } else {
          selectedKeys = this.state.selectedKeys
          isCollaps = !isCollaps
        }
      }
      this.setState({
        isCollaps,
        selectedKeys
      })
    } else {
      const href = hrefs[menu.key]
      if (href && href !== pathname) {
        history && history.push(href)
        isCollaps = true
      } else if (this.state.selectedKeys) {
        isCollaps = true
      } else {
        isCollaps = !isCollaps
      }
      this.setState({
        isCollaps,
        selectedKeys: null
      })
    }
  }

  getDefaultKeys = () => {
    const {
      location: { pathname }
    } = this.props
    const pathArr = pathname.split('/')
    let target = this.state.menuList.find(
      (item) =>
        _.includes(pathArr, item.path) ||
        _.get(item, 'subMenu', []).find((subItem) =>
          _.includes(pathArr, subItem.path)
        )
    )
    if (target && target.subMenu) {
      target = target.subMenu.find((subItem) =>
        _.includes(pathArr, subItem.path)
      )
      return target.keys
    } else if (target && target.key) {
      return [target.key]
    } else {
      return ['profile', 'overview']
    }
  }

  componentDidMount() {
    const selectedKeys = this.getDefaultKeys()
    this.setState({ selectedKeys, isCollaps: true })

    switch (this.props.account.user.person_character) {
      case CharacterLevel.admin:
      case CharacterLevel.expert:
      case CharacterLevel.super_admin:
        const menuList = getMenuList(
          this.props.loginRole,
          [],
          this.props.account
        )
        this.setState({ menuList })
        break
      default:
        break
    }
  }

  componentDidUpdate(prevProps) {
    const {
      loginRole,
      location: { pathname },
      datasetCount,
      account
    } = this.props

    if (pathname !== prevProps.location.pathname) {
      const selectedKeys = this.getDefaultKeys()
      if (
        this.state.selectedKeys &&
        !_.includes(this.state.selectedKeys, selectedKeys[0])
      ) {
        this.setState({ selectedKeys, isCollaps: true })
      }
    }

    if (datasetCount && this.state.menuList.length === 0) {
      const menuList = getMenuList(loginRole, [], account)
      this.setState({ menuList })
    }
  }

  getSelectedKeys = (path) => {
    const { isCollaps, selectedKeys } = this.state
    const {
      slideMenu: { groups, currentCategory }
    } = this.props
    const pathArr = path.split('/')
    let keys = []
    let target = this.state.menuList.find((item) =>
      _.includes(pathArr, item.path)
    )
    if (isCollaps) {
      if (selectedKeys) {
        keys = selectedKeys
      } else if (target) {
        keys.push(target.key)
        if (target.subMenu) {
          const subTarget = target.subMenu.find((item) =>
            pathArr.find((p) => p === item.path)
          )
          if (subTarget) {
            keys.push(subTarget.key)
          }
        }
      }
      if (target && target.hasSubMenu) {
        const subList = _.get(groups, `${target.menuKey}.categories`, []).map(
          (item) => item.name
        )
        if (_.includes(subList, currentCategory)) {
          if (keys.length > 1) {
            keys = keys.filter((key) => !_.includes(key, target.path))
          }
          keys.push(`${target.path}+${currentCategory.replace(/ /g, '_')}`)
        }
      }
    }
    if (!keys.length) {
      keys.push('profile')
    }

    return keys
  }

  typeLink = (type) => {
    const {
      location: { pathname },
      hrefs,
      history
    } = this.props

    const href = hrefs[type]
    if (!pathname.match(href)) {
      history && history.push(href)
    }
  }

  renderSubmenu(targetMenu) {
    const {
      slideMenu: { groups }
    } = this.props
    if (targetMenu.subMenu) {
      return (
        <SubMenu
          key={targetMenu.key}
          title={targetMenu.menuTitle}
          onTitleClick={() => this.subMenuClickHandle(targetMenu)}
        >
          {targetMenu.subMenu.map((item) => (
            <Item
              key={item.key}
              className={item.className}
              disabled={item.disabled}
            >
              <span> {item.menuTitle}</span>
            </Item>
          ))}
        </SubMenu>
      )
    }
    return (
      <SubMenu
        key={targetMenu.key}
        disabled={disabled(targetMenu.menuKey, null, this.props)}
        title={targetMenu.menuTitle}
        onTitleClick={() => this.subMenuClickHandle(targetMenu)}
      >
        {groups &&
          groups[targetMenu.menuKey].categories.map((item) => (
            <Item
              key={`${targetMenu.path}+${item.name.replace(/ /g, '_')}`}
              disabled={disabled(targetMenu.menuKey, item, this.props)}
            >
              <Link to={`category_${item.name}`}>{item.name}</Link>
            </Item>
          ))}
      </SubMenu>
    )
  }

  render() {
    const {
      location: { pathname },
      client,
      loginRole
    } = this.props
    const defaultKeys = this.getSelectedKeys(pathname)
    const menuList = getMenuList(
      this.props.loginRole,
      this.props.datasetCount,
      this.props.account
    )
    return (
      <div className={`${styles} ${loginRole}`}>
        <Menu
          onClick={this.handleClick}
          selectedKeys={defaultKeys}
          openKeys={defaultKeys}
          mode="inline"
        >
          {menuList.map((item) => {
            if (item.key === 'message') {
              return (
                <Item
                  key={item.key}
                  className={item.className}
                  disabled={item.disabled}
                >
                  {item.menuTitle}
                  <Badge
                    count={client ? client.unreadCount : 0}
                    overflowCount={99}
                    style={{
                      marginLeft: '10px'
                    }}
                  />
                </Item>
              )
            }
            return item.hasSubMenu ? (
              this.renderSubmenu(item)
            ) : (
              <Item
                key={item.key}
                className={item.className}
                disabled={item.disabled}
              >
                {item.menuTitle}
              </Item>
            )
          })}
        </Menu>
      </div>
    )
  }
}

export default connect(
  ({ slideMenu, client, account }) => ({
    slideMenu,
    client,
    account
  }),
  null
)(ClientSlideMenu)

function disabled(key, category, props) {
  const { datasetCount, loginRole, fileAvailableTypes } = props
  const user = loadUser()
  const isPartner = user.profile.account_type === userType.Partners
  if (
    !loginRole ||
    loginRole === 'Expert' ||
    loginRole === 'InternalAdmin' ||
    isPartner
  )
    return false
  if (!datasetCount) return true
  const target = datasetCount.find((item) => item.group === key)
  if (target) {
    if (target.count > 0 && target.category_ids.length > 0) {
      if (category) {
        const subIds = category.subcategory_ids
        subIds.push(category.id)
        for (const subid of subIds) {
          for (const category_id of target.category_ids) {
            if (subid === category_id) {
              return false
            }
          }
        }
        return true
      }
      return false
    } else {
      return fileAvailableTypes && !fileAvailableTypes.includes(key)
    }
  } else {
    return category === undefined
      ? fileAvailableTypes && !fileAvailableTypes.includes(key)
      : true
  }
}

function getMenuList(loginRole, datasetCount = [], account) {
  const accessiblePages = account.permissions.pages.map((p) => p.name)

  let menuList = [
    // {
    //   key: 'home',
    //   disabled: true,
    //   className: 'home',
    //   menuTitle: 'HOME',
    //   permission: ['Expert', 'User', 'InternalAdmin']
    // },
    {
      path: 'profile',
      key: 'profile',
      menuTitle: 'Home',
      characters: [CharacterLevel.service_provider]
      // permission: ['Service_Provider']
    },
    {
      path: 'profile',
      key: 'profile',
      keys: ['profile', 'overview'],
      // permission: ['Expert', 'User', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.service_provider]),
      menuTitle: 'Home'
    },
    {
      path: 'timeline',
      key: 'timeline',
      // permission: ['Expert', 'InternalAdmin'],
      characters: [
        CharacterLevel.expert,
        CharacterLevel.admin,
        CharacterLevel.super_admin
      ],
      menuTitle: 'Timeline',
      perm: TIMELINE
    },
    {
      path: 'questionnaire',
      key: 'questionnaire',
      // keys: ['questionnaire', ''],
      menuTitle: 'Questionnaire',
      // permission: ['Expert', 'User', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.service_provider])
    },
    {
      path: 'message',
      key: 'message',
      menuTitle: 'Chat',
      // permission: ['User', 'Expert', 'Service_Provider', 'InternalAdmin'],
      characters: ExcludeCharacters([]),
      perm: MESSAGING
    },
    {
      path: 'notes',
      key: 'notes',
      menuTitle: 'Notes',
      // permission: ['Expert', 'Service_Provider', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.client]),
      perm: NOTES
    },
    {
      path: 'support-team',
      key: 'support_team',
      menuTitle: 'Support Team',
      // permission: ['User', 'Expert', 'Service_Provider', 'InternalAdmin'],
      characters: ExcludeCharacters([]),
      perm: SUPPORT_TEAM
    },
    {
      key: 'program',
      path: 'program',
      menuTitle: 'Program (Archive)',
      // permission: ['Expert', 'Service_Provider', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.client]),
      perm: PROGRAM
    },
    {
      path: 'trends', //'goals',
      key: 'trends', //'micro_goals',
      menuTitle: 'Trends',
      className: 'greyed-out',
      // permission: ['Expert', 'User', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.service_provider]),
      perm: TRENDS
    },
    {
      path: 'setting',
      key: 'setting',
      menuTitle: 'Profile & Settings',
      // permission: ['User', 'Expert', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.service_provider])
    },
    {
      key: 'email',
      path: 'summary-email',
      menuTitle: 'Weekly Insights',
      // permission: ['Expert', 'InternalAdmin', 'User', 'Service_Provider'],
      characters: ExcludeCharacters([]),
      perm: WEEKLY_INSIGHTS
    },
    {
      path: 'resource',
      key: 'resource',
      menuTitle: 'Resources',
      // permission: ['User'],
      characters: [CharacterLevel.client]
    },
    {
      key: 'file',
      path: 'file',
      menuTitle: 'Files',
      isPlaceholder: true,
      // permission: ['Expert', 'InternalAdmin', 'User', 'Service_Provider'],
      characters: ExcludeCharacters([]),
      perm: FILES
    },
    {
      key: 'assessment',
      className: 'assessment',
      disabled: true,
      menuTitle: 'Result',
      // permission: ['User', 'Expert', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.service_provider]),
      style: {
        color: `rgba(50, 63, 74, 0.8) ${
          !(datasetCount && datasetCount.length > 0) ? '!important' : ''
        }`
      }
    },
    {
      // path: 'ass-report',
      key: 'health_compass', //'ass_report',
      keys: ['health_compass'],
      menuTitle: '360 Health Compass', //'360 Review & Milestone Planning',
      // permission: ['Expert', 'User', 'Service_Provider', 'InternalAdmin'],
      characters: ExcludeCharacters([]),
      perm: HEALTH_COMPASS,
      hasSubMenu: true,
      subMenu: [
        {
          path: 'export-data',
          key: 'export_data',
          keys: ['export_data', 'health_compass'],
          menuTitle: 'Export Data'
        },
        {
          path: 'health-score',
          key: 'health_score',
          keys: ['health_score', 'health_compass'],
          menuTitle: 'Health Compass'
        },
        {
          path: 'ass-report',
          key: 'ass_report',
          keys: ['ass_report', 'health_compass'],
          menuTitle: 'Assessment Review'
        }
      ]
    },
    {
      path: 'nutrition-score',
      key: 'nutrition_score',
      className: 'greyed-out',
      menuTitle: 'Nutrition Signals Report',
      // permission: ['Expert', 'User', 'InternalAdmin'],
      characters: ExcludeCharacters([CharacterLevel.service_provider]),
      perm: NUTRITION_SIGNALS_REPORT
    },
    {
      path: 'nutrition-trends',
      key: 'nutrition_trends',
      className: 'greyed-out',
      menuTitle: 'Nutrition Signals Trends',
      // permission: ['Expert', 'InternalAdmin'],
      characters: [
        CharacterLevel.super_admin,
        CharacterLevel.expert,
        CharacterLevel.admin
      ],
      perm: NUTRITION_SIGNALS_TRENDS
    }

    // {
    //   path: 'life-style',
    //   key: 'lifestyle',
    //   menuKey: 'lifestyle_assessment',
    //   menuTitle: 'Lifestyle',
    //   permission: ['Expert', 'User', 'InternalAdmin'],
    //   hasSubMenu: true
    // }
  ]

  if (
    account.user.person_character === CharacterLevel.client ||
    account.user.person_character === CharacterLevel.service_provider
  ) {
    menuList = menuList.concat(
      datasetTypes.filter((dataset) => {
        const target = datasetCount.find(
          (item) => item.group === dataset.menuKey
        )
        if (target && target.count > 0 && target.category_ids.length > 0) {
          return true
        } else {
          return false
        }
      })
    )
  } else {
    menuList = menuList.concat(datasetTypes)
  }

  return menuList
    .filter((item) =>
      _.includes(item.characters, account.user.person_character)
    )
    .filter((item) =>
      item.perm ? _.includes(accessiblePages, item.perm) : true
    )
}
